import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  width: ${({ size }) => {
    switch (size) {
      case 'small':
        return '16px';
      case 'medium':
        return '20px';
      case 'large':
        return '24px';
      case 'xlarge':
        return '32px';
      default:
        return '20px';
    }
  }};
  
  height: ${({ size }) => {
    switch (size) {
      case 'small':
        return '16px';
      case 'medium':
        return '20px';
      case 'large':
        return '24px';
      case 'xlarge':
        return '32px';
      default:
        return '20px';
    }
  }};
  
  color: ${({ theme, color }) => {
    if (!color) return theme.colors.text.primary;
    if (typeof color === 'string' && color.startsWith('#')) return color;
    return theme.colors.text[color] || theme.colors[color] || color;
  }};
  
  transition: color ${({ theme }) => theme.duration.fast}ms ${({ theme }) => theme.easing.easeOut};
  
  ${({ spin }) => spin && `
    animation: spin 1s linear infinite;
    
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `}
  
  ${({ pulse }) => pulse && `
    animation: pulse 2s ease-in-out infinite;
    
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.5;
      }
    }
  `}
  
  ${({ bounce }) => bounce && `
    animation: bounce 1s ease-in-out infinite;
    
    @keyframes bounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-25%);
      }
    }
  `}
`;

const Icon = React.forwardRef(
  ({ children, size = 'medium', color, spin = false, pulse = false, bounce = false, ...props }, ref) => {
    return (
      <StyledIcon
        ref={ref}
        size={size}
        color={color}
        spin={spin}
        pulse={pulse}
        bounce={bounce}
        {...props}
      >
        {children}
      </StyledIcon>
    );
  }
);

Icon.displayName = 'Icon';

export default Icon;